import React from "react";


export default function IncomingCallModal({ data, onAccept, onReject }) {


 if (!data || data.length === 0) return null;

  return (
    <div className="incoming-call-container">
      {
        data && data?.map((item) => (
          <div className="incoming-call-modal flex flex-col justify-between ">
            <div>
              <p><span className="font-semibold">{item?.incomingCall?.callerName}</span> is waiting for you. Please join the call.</p>
            </div>
            <div className="incoming-call-actions">
              <button className="reject-btn" onClick={() => onReject(item?.incomingCall?.callerId)}>Cancel</button>
              <button className="accept-btn" onClick={() => onAccept(item?.incomingCall?.callerId)}>Join</button>
            </div>
          </div>
        ))
      }

    </div>
  );
}
